import openInNewTab from "../../../utils/openInNewTab";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";
import { ebayMakeModelYearCategoryQuery, ebaySearchString } from "../../../utils/ebaySearchString";
import classNames from "../../../utils/classNames";

/** The vehicle / category / part-number fields the unlisted eBay sold searches need. IPart satisfies this. */
export type IEbaySearchPartFields = {
  partNumber?: string | null;
  oePartNumber?: string | null;
  vehicle?: {
    dvlaYearOfManufacture?: number | null;
    combinedMake?: string | null;
    modelRangeDescription?: string | null;
  } | null;
  category?: { name?: string | null } | null;
};

/**
 * Sold-and-completed eBay searches: year + make + model + category, then the MPN and OEM.
 * Compact is for table cells (Pricing); default matches the unlisted expanded row.
 */
export default function UnlistedEbaySearchButtons({
  part,
  compact = false,
}: {
  part: IEbaySearchPartFields;
  compact?: boolean;
}) {
  const makeModelQuery =
    part.vehicle?.combinedMake && part.vehicle?.modelRangeDescription
      ? ebayMakeModelYearCategoryQuery({
          dvlaYearOfManufacture: part.vehicle.dvlaYearOfManufacture,
          combinedMake: part.vehicle.combinedMake,
          modelRangeDescription: part.vehicle.modelRangeDescription,
          categoryName: part.category?.name,
        })
      : null;

  const mpn = (part.partNumber ?? "").trim();
  const oe = (part.oePartNumber ?? "").trim();
  const buttonClasses = compact
    ? "bg-primary text-white hover:text-white hover:bg-primary-700 px-2 py-1"
    : "bg-primary text-white hover:text-white hover:bg-primary-700 px-3 py-2";
  const logoClasses = compact ? "h-3.5 w-7" : "h-5 w-10";
  const labelClasses = compact ? "flex items-center gap-x-1.5 text-xs" : "flex items-center gap-x-3";

  return (
    <div className={classNames("flex", compact ? "flex-col items-stretch gap-1" : "gap-x-4")}>
      {makeModelQuery && (
        <ButtonInput onClick={() => openInNewTab(ebaySearchString(makeModelQuery))} classes={buttonClasses}>
          <span className={labelClasses}>
            Search Make, Model, Year & Category
            <img src="/ebayLogo.svg" alt="eBay" className={logoClasses} />
          </span>
        </ButtonInput>
      )}

      {mpn && (
        <ButtonInput onClick={() => openInNewTab(ebaySearchString(mpn))} classes={buttonClasses}>
          <span className={labelClasses}>
            Search {mpn}
            <img src="/ebayLogo.svg" alt="eBay" className={logoClasses} />
          </span>
        </ButtonInput>
      )}

      {oe && oe !== mpn && (
        <ButtonInput onClick={() => openInNewTab(ebaySearchString(oe))} classes={buttonClasses}>
          <span className={labelClasses}>
            Search {oe}
            <img src="/ebayLogo.svg" alt="eBay" className={logoClasses} />
          </span>
        </ButtonInput>
      )}
    </div>
  );
}
